import { render, staticRenderFns } from "./searchBtn.vue?vue&type=template&id=4ea995b6"
import script from "./searchBtn.vue?vue&type=script&lang=js"
export * from "./searchBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports